module.exports = __webpack_public_path__ + "static/img/default-avatar.502b3c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default-avatar.png
// module id = SIH0
// module chunks = 29